// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2OYtg","content":"Consent_content__3rFTb","footer":"Consent_footer__2Xy1k"};